export class Orgsetting {
    organizationId:string;
    orglanguage:string;
    created:Date;
    createdby:string;
}